import angular from 'angular';
import careerComponent from './career.component';

import careerIntro from './career-intro/career-intro';
import developers from './developers/developers';
import uiDesign from './ui-design/ui-design';
import administrative from './administrative/administrative';
import algorithms from './algorithms/algorithms';
import products from './products/products';
import ai from './ai/ai'
import system from './system/system'

let childModules = [
    careerIntro,
    developers,
    uiDesign,
    administrative,
    algorithms,
    products,
    ai,
    system
];

let states = [
    {
        name: 'career',
        abstract: true,
        component: 'career'
    }
];

let childModuleNames = [];

childModules.forEach((m) => {
    childModuleNames.push(m.name);

    m.states.forEach((s) => {

        s.name = 'career.' + s.name;

        states.push(s);
    });
});

let careerModule = angular.module('career', childModuleNames)

    .component('career', careerComponent)

    .name;

export default {name: careerModule, states: states};



// WEBPACK FOOTER //
// ./src/app/components/page/career/career.js